/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EmailVerified.css";
import { simpleFetch } from "../../restWrapper";
import { PLATFORM } from "../../config";
import PropTypes from "prop-types";
//import Promise from 'bluebird';

class EmailVerified extends Component {
  constructor() {
    super();
    this.state = {
      fetching: true,
      isDonor: false,
      isOrg: true,
    };
    this.btnClick = this.btnClick.bind(this);
  }

  componentDidMount() {
    const path = this.props.location.pathname;
    const token = path.split("/EmailVerified/")[1];
    if (!token) {
      this.fail();
    }
    this.handleToken(token);
  }

  handleToken(token) {
    /*
    Promise.all([
      this.handleUserToken(token, 'donors'),
      this.handleUserToken(token, 'organizations')
    ]).then((res) => {
      this.setState({
        fetching:false
      });
      if(res[0] === true){
        this.setState({
          isDonor: true
        });
      }else if(res[1] === true){
        this.setState({
          isOrg: true
        });
      }else {
        this.fail();
      }
    });
    */
    this.handleUserToken(token, "donors");
  }

  handleUserToken(token, userType) {
    const url = "/" + userType + "/register/" + token;
    simpleFetch(url, "GET").then((res) => {
      this.setState({
        fetching: false,
      });
      if (res.status !== 204) this.fail();
      return true;
    });
  }

  fail() {
    this.props.history.push({ pathname: "/ErrorPrompt" });
  }

  btnClick() {
    if (!this.state.isOrg) return;
    // A nonprofit that signed up on Plug verifies from a Plug-branded email
    // on the Plug domain, so /OrgLogin — the CheckPlus org sign-in — is not
    // where it came from and not where it can get back to (CP-304). The
    // marketplace opens its own sign-in from the query string.
    if (PLATFORM === "plug") {
      this.props.history.push({ pathname: "/webapp", search: "?login=1" });
      return;
    }
    this.props.history.push({ pathname: "/OrgLogin" });
  }

  render() {
    if (this.state.fetching) {
      return <this.props.RenderFullPageLoading />;
    }
    const languageObj = this.props.languageObj;
    return (
      <div className="EmailVerified-view">
        <div className="EmailVerified-header">
          <div className="EmailVerified-CheckPlusLogoContainer">
            <div
              className={
                PLATFORM === "plug"
                  ? "EmailVerified-PlugLogo"
                  : "EmailVerified-CheckPlusLogo"
              }
            />
          </div>
        </div>

        <div className="EmailVerified-centerContainer">
          <div className="EmailVerified-prompt">
            <div className="EmailVerified-loginContainer">
              <div className="EmailVerified-mailVerifyIcn"></div>
              <div className="EmailVerified-heading">{languageObj.text3}</div>
              <div className="EmailVerified-completedIcn" />
            </div>
          </div>

          <div className="EmailVerified-spaceInBetween"></div>

          <div className="EmailVerified-prompt">
            <div className="EmailVerified-loginContainer">
              <div className="EmailVerified-documentIcn"></div>
              <div className="EmailVerified-heading">{languageObj.text4}</div>
              {this.state.isOrg && (
                <div onClick={this.btnClick} className="EmailVerified-loginBtn">
                  {languageObj.loginBtn}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
EmailVerified.propTypes = {
  languageObj: PropTypes.object,
};

export default EmailVerified;
